import { ExpenseStatus } from 'core/domain/expenses/expenseStatus'

export const mapExpenseStatusWithIcon = new Map<number, string>([
  [ExpenseStatus.Verified, 'far fa-check-circle'],
  [ExpenseStatus.ActionRequired, 'far fa-exclamation-circle'],
  [ExpenseStatus.AwaitingReview, 'far fa-clock'],
  [ExpenseStatus.Ineligible, 'far fa-times-circle'],
])

export const mapExpenseStatusWithColor = new Map<number, string>([
  [ExpenseStatus.Verified, 'color-green-6'],
  [ExpenseStatus.ActionRequired, 'color-yellow-7'],
  [ExpenseStatus.AwaitingReview, 'color-blue-6'],
  [ExpenseStatus.Ineligible, 'color-red-6'],
])

export const mapExpenseStatusWithExplanationTitle = new Map<number, string>([
  [ExpenseStatus.Verified, 'reimbursement-requests.verified-as-of-label'],
  [ExpenseStatus.ActionRequired, 'reimbursement-requests.action-required-as-of-label'],
  [ExpenseStatus.AwaitingReview, 'reimbursement-requests.awaiting-review-as-of-label'],
  [ExpenseStatus.Ineligible, 'reimbursement-requests.ineligible-as-of-label'],
])

export const mapExpenseStatusWithTitle = new Map<number, string>([
  [ExpenseStatus.Verified, 'reimbursement-requests.verified-label'],
  [ExpenseStatus.ActionRequired, 'reimbursement-requests.action-required-label'],
  [ExpenseStatus.AwaitingReview, 'reimbursement-requests.awaiting-review-label'],
  [ExpenseStatus.Ineligible, 'reimbursement-requests.ineligible-label'],
])

export const mapExpenseStatusWithContent = new Map<number, string>([
  [ExpenseStatus.AwaitingReview, 'reimbursement-requests.awaiting-review-content'],
])
